/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const SOCKET = project.getFeature(feature.getSettingValue('SOCKET'));
    if (!SOCKET) {
        return blocks;
    }
    const NAME = SOCKET.getSettingValue('NAME');

    const links = project.getNodeLinks(feature, 'sock_send');
    for (let i = 0; i < links.length; i += 1) {
        const link = links[0];
        const source: BaseNode = project.getFeature(link.getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(link.getSettingValue('SOURCE_PORT'))?.params;
        const DATA = feature.project.parseCodeExpression(feature.getSettingValue('DATA'), sourceParams, TibboDataType.STRING);

        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
if (${NAME}_SOCK_NUM < 0) {
    LOG_INF("Socket not connected");    
} else {
    string buffer_${feature.getID()} = ${DATA};
    send(${NAME}_SOCK_NUM, buffer_${feature.getID()}.c_str(), buffer_${feature.getID()}.length(), 0);
}`,
        });
    }


    return blocks;
};
